<template>
    <div class="flex">

        <ChevronLeft
            :class="{ 'cursor-default opacity-50 pointer-events-none' : value === 1 }"
            class="w-4 h-4 text-grey-dark mr-2 cursor-pointer hover-opacity"
            @click="prevPage"
        />
        <ChevronRight
            class="w-4 h-4 text-grey-dark cursor-pointer hover-opacity"
            @click="nextPage"
        />

    </div>
</template>

<script>
import ChevronLeft from '~/static/images/chevron-left.svg';
import ChevronRight from '~/static/images/chevron-right.svg';

export default {

    components: {
        ChevronLeft,
        ChevronRight,
    },

    props: {
        value: {
            type: Number,
            required: true,
        },
    },

    methods: {
        nextPage() {
            this.$emit('input', this.value + 1);
        },
        prevPage() {
            this.$emit('input', this.value - 1);
        },
    },

};
</script>

<style lang="scss" scoped>
.hover-opacity {
    @apply transition-fast;
    &:hover {
        @apply opacity-75;
    }
}
</style>
